import { Brand, CatalogImage } from '@src/types/graphql-types'
import { SectionName } from '@src/components/ProductInfo/SkipToSectionTypes'
import { LegacyRef, ReactNode, RefObject } from 'react'
import messages from '@utils/messages'

export enum CarouselProductTypes {
  RecentlyViewed = 'recently viewed products',
  AlsoViewed = 'customers also viewed',
  CompareItems = 'compare similar items',
  RecommendedProducts = 'recommended products',
  CartRecommendedProducts = 'recommended products', // Used as a special type to trigger certain CSS rendering.
  PopularProducts = 'popular products',
  BestSellers = 'best sellers',
  NewArrivals = 'new arrivals',
  TopDeals = 'top deals',
  FeaturedProducts = 'featured products',
  BuyAgain = 'buy it again',
  RelatedProducts = 'related products',
  HeroCard = 'product hero card',
}

export const CAROUSEL_TITLE_LOOKUP_BY_TYPE = {
  [CarouselProductTypes.RecommendedProducts]: messages.RECOMMENDED_PRODUCTS,
  [CarouselProductTypes.RelatedProducts]: messages.RELATED_PRODUCTS,
  [CarouselProductTypes.RecentlyViewed]: messages.RECENTLY_VIEWED_PRODUCTS,
  [CarouselProductTypes.AlsoViewed]: messages.CUSTOMERS_ALSO_VIEWED,
  [CarouselProductTypes.BestSellers]: {
    id: 'SHOP_BEST_SELLERS',
    defaultMessage: 'Shop Best Sellers',
  },
  [CarouselProductTypes.BuyAgain]: {
    id: 'BUY_IT_AGAIN',
    defaultMessage: 'Buy It Again',
  },
  [CarouselProductTypes.NewArrivals]: messages.NEW_PRODUCT,
  [CarouselProductTypes.PopularProducts]: {
    id: 'POPULAR_PRODUCTS',
    defaultMessage: 'Popular Products',
  },
}

export interface CarouselProduct {
  id?: string | null
  productKey: string
  productNumber: string
  name: string
  description?: string | null
  gaProductCode?: string | null
  brand: Pick<Brand, 'key' | 'erpKey' | 'name' | 'color'>
  images: Pick<CatalogImage, 'altText' | 'mediumUrl'>[]
  isMarketplace: boolean
  tags?: string | null
  discount?: string | null
  analyticsPosition?: number // Lets us override the index/position of the item that is reported to analytics. This occurs on carousel slices for next/prev navigation.
}

export interface ProductCardProps {
  type: CarouselProductTypes
  withoutControls?: boolean
  slidesToShow?: number
  condensed?: boolean
  preloadCardImages?: boolean
  products: CarouselProduct[]
  isRaisedCardLayout?: boolean
  title?: JSX.Element | string
  productHeroCard?: boolean
  isProductRecommendation?: boolean
  hideProductImg?: boolean
  showPdpRedesignLevelTwo?: boolean
  displayDiscount?: (discountPercent?: string | null) => ReactNode
  updateSkipToLinks?: (sectionName: SectionName, ref: RefObject<null>) => void
  setRef?: (refType: string) => LegacyRef<HTMLDivElement> | undefined

  // Analytics values we allow to be prop drilled down into carousels. Which isn't ideal but... Gotta do what you gotta do.
  analyticsPageName?: string
  analyticsPageDetails?: string
}
